"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("jquery-ui/ui/widgets/datepicker");
const jquery_1 = __importDefault(require("jquery"));
const lightbox_1 = __importDefault(require("lightbox2/src/js/lightbox"));
function switchTopSearchButton($) {
    $('#search_submit').hide();
    $('#search_submit_link')
        .show()
        .on('click', () => {
        $('#top_search').trigger('submit');
        return false;
    });
}
function verticallyAlignToCenter($) {
    $('.v_center').each(function () {
        var _a, _b;
        const $this = $(this);
        const $parent = $this.parent();
        const marginTop = (((_a = $parent.height()) !== null && _a !== void 0 ? _a : 0) - ((_b = $this.height()) !== null && _b !== void 0 ? _b : 0)) / 2;
        $this.css('margin-top', `${marginTop}px`);
    });
}
exports.default = {
    init() {
        lightbox_1.default.option({
            wrapAround: true,
            showImageNumberLabel: false,
        });
        (0, jquery_1.default)('.js-datepicker').datepicker({
            dateFormat: 'yy-mm-dd',
        });
        (0, jquery_1.default)(window).on('load', () => verticallyAlignToCenter(jquery_1.default));
        // top search
        switchTopSearchButton(jquery_1.default);
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
